<div style="height: 80%;">
    <app-map class="full-size" [mapContainerCss]="'full-size'" [markersLocations]="markerLocations"
    (selectedMarkrId)="onMakrerSelected($event)"></app-map>
</div>
